const mapDOM = document.querySelector('#map');

if (mapDOM) {
	window.mapboxgl.accessToken = 'pk.eyJ1Ijoid2ViLWlkZWEiLCJhIjoiY2t4NGo0OXB6MTY4dDJ1dXFxbzczZmp6NiJ9.KpzE7WQEVkf28s5JmI2KiQ';
	const coordinates = [6.088647555811908, 48.61400124113243];
	const map = new window.mapboxgl.Map({
		container: 'map', // container ID
		style: 'mapbox://styles/web-idea/ckelf1nb519bu1at2xxhzmmqm', // style URL
		center: coordinates, // starting position [lng, lat]
		zoom: 10 // starting zoom
	});

	new window.mapboxgl.Marker({
		color: '#3C5CA9',
		draggable: false
	}).setLngLat(coordinates)
	.addTo(map);

}




// WEBPACK FOOTER //
// ./scripts/modules/map.js